// extracted by mini-css-extract-plugin
export var container = "index-module--container--VH0ZR";
export var description = "index-module--description--K-f55";
export var errorPuppy = "index-module--errorPuppy--cH8kg";
export var main = "index-module--main--iYtia";
export var mobileDescriptionBox = "index-module--mobileDescriptionBox--Usu3c";
export var title = "index-module--title--5KIs4";